<template functional>
  <table class="entsys--table registration-details-table">
    <colgroup>
      <col />
      <col />
      <col />
      <col />
      <col />
      <col />
    </colgroup>
    <tbody>
      <template v-for="(registration, i) in props.registrations">
        <tr :key="i" class="primary header">
          <td colspan="99" class="white--text">
            <div
              class="d-flex flex-column flex-md-row registration-pair-details"
            >
              <template
                v-if="
                  registration.athletes.length || registration.horses.length
                "
              >
                <span>{{
                  parent.$t("events:common.Athletes.label", "Athletes")
                }}</span>
                <AppShowPersonName
                  v-for="athlete in registration.athletes"
                  :key="athlete.id"
                  :person="athlete"
                  class="mx-1 white--text"
                /><span class="hidden-sm-and-down mx-2">-</span>
                <span>{{
                  parent.$t("events:common.Horses.label", "Horses")
                }}</span>
                <template v-if="registration.horses.some(x => x.isHorseSlot)">
                  <AppHorseSlot />
                </template>
                <template v-else>
                  <AppShowHorseName
                    v-for="horse in registration.horses"
                    :key="horse.id"
                    :horse="horse"
                    class-list="mx-1 white--text"
                  />
                </template>
              </template>
            </div>
          </td>
        </tr>
        <template v-if="registration.expenseItems.length">
          <tr :key="i + '-expenseItems'" class="sub-header">
            <td colspan="2" class="text-left font-weight-bold">
              {{
                parent.$t(
                  "people:ShoppingBasket.Events.PersonEventFinancialReport.expensesAndIncomes.expenses.label",
                  "Expenses"
                )
              }}
            </td>

            <td class="text-right font-weight-bold hidden-sm-and-down">
              {{
                parent.$t(
                  "people:ShoppingBasket.Events.PersonEventFinancialReport.expensesAndIncomes.amount.label",
                  "Amount"
                )
              }}
            </td>
            <td class="text-right font-weight-bold hidden-sm-and-down">
              {{
                parent.$t(
                  "people:ShoppingBasket.Events.PersonEventFinancialReport.expensesAndIncomes.vatPercent.label",
                  "VAT %"
                )
              }}
            </td>

            <td class="text-right font-weight-bold hidden-sm-and-down">
              {{
                parent.$t(
                  "people:ShoppingBasket.Events.PersonEventFinancialReport.expensesAndIncomes.vatAmount.label",
                  "VAT amount"
                )
              }}
            </td>
            <td class="text-right font-weight-bold hidden-sm-and-down">
              {{
                parent.$t(
                  "people:ShoppingBasket.Events.PersonEventFinancialReport.expensesAndIncomes.totalAmount.label",
                  "Total amount"
                )
              }}
            </td>
          </tr>
          <tr
            v-for="(expense, index) in registration.expenseItems"
            :key="expense.id + '-expense-' + index"
          >
            <td v-if="$options.getName(expense, parent)" class="text-left">
              {{ $options.getName(expense, parent) }}
              <template
                v-if="
                  expense.registrationEventProduct &&
                  expense.registrationEventProduct.entry &&
                  expense.registrationEventProduct.entry.competition
                "
                >(<AppShowCompetitionCodeAndName
                  :competition="
                    expense.registrationEventProduct.entry.competition
                  "
                />)</template
              >
            </td>
            <td :colspan="!$options.getName(expense, parent) ? 2 : 1">
              {{
                expense.aggregatedByEntityClass == "PriceComponent"
                  ? parent.$t(
                      `people:ShoppingBasket.Events.PersonEventBalancesReport.expenseItems.${expense.aggregatedByEntityClass}.${expense.priceComponentCodename}.label`,
                      expense.aggregatedByEntityClass
                    )
                  : parent.$t(
                      `people:ShoppingBasket.Events.PersonEventBalancesReport.expenseItems.${expense.aggregatedByEntityClass}.label`,
                      expense.aggregatedByEntityClass
                    )
              }}
            </td>

            <td>
              <div class="d-flex flex-row justify-space-between">
                <div class="hidden-md-and-up d-print-none font-weight-bold">
                  {{
                    parent.$t(
                      "people:ShoppingBasket.Events.PersonEventFinancialReport.expensesAndIncomes.amount.label",
                      "Amount"
                    )
                  }}
                </div>
                <div class="text-right">
                  {{ parent.masterCurrency(expense.amountExludingVatCents) }}
                </div>
              </div>
            </td>
            <td class="text-right">
              <div class="d-flex flex-row justify-space-between">
                <div class="hidden-md-and-up d-print-none font-weight-bold">
                  {{
                    parent.$t(
                      "people:ShoppingBasket.Events.PersonEventFinancialReport.expensesAndIncomes.vatPercent.label",
                      "VAT %"
                    )
                  }}
                </div>
                <div class="text-right">
                  {{ expense.vatRatePercentage + "%" }}
                </div>
              </div>
            </td>
            <td class="text-right">
              <div class="d-flex flex-row justify-space-between">
                <div class="hidden-md-and-up d-print-none font-weight-bold">
                  {{
                    parent.$t(
                      "people:ShoppingBasket.Events.PersonEventFinancialReport.expensesAndIncomes.vatAmount.label",
                      "VAT amount"
                    )
                  }}
                </div>
                <div class="text-right">
                  {{ parent.masterCurrency(expense.vatAmountCents) }}
                </div>
              </div>
            </td>
            <td class="text-right">
              <div class="d-flex flex-row justify-space-between">
                <div class="hidden-md-and-up d-print-none font-weight-bold">
                  {{
                    parent.$t(
                      "people:ShoppingBasket.Events.PersonEventFinancialReport.expensesAndIncomes.totalAmount.label",
                      "Total amount"
                    )
                  }}
                </div>
                <div class="text-right">
                  {{ parent.masterCurrency(expense.amountCents) }}
                </div>
              </div>
            </td>
          </tr>
        </template>
        <template v-if="registration.revenueItems.length">
          <tr :key="i + '-revenueItems'" class="sub-header">
            <td colspan="99" class="text-left font-weight-bold">
              {{
                parent.$t(
                  "people:ShoppingBasket.Events.PersonEventFinancialReport.expensesAndIncomes.income.label",
                  "Income"
                )
              }}
            </td>
          </tr>
          <tr
            v-for="(revenue, index) in registration.revenueItems"
            :key="revenue.id + '-revenue-' + index"
          >
            <td v-if="$options.getName(revenue, parent)" class="text-left">
              {{ $options.getNameForRevenue(revenue, parent) }}
            </td>
            <td :colspan="!$options.getName(revenue, parent) ? 2 : 1">
              {{
                parent.$t(
                  `people:ShoppingBasket.Events.PersonEventBalancesReport.revenueItems.${revenue.aggregatedByEntityClass}.label`,
                  revenue.aggregatedByEntityClass
                )
              }}
            </td>
            <td class="text-right">
              <div class="d-flex flex-row justify-space-between">
                <div class="hidden-md-and-up d-print-none font-weight-bold">
                  {{
                    parent.$t(
                      "people:ShoppingBasket.Events.PersonEventFinancialReport.expensesAndIncomes.amount.label",
                      "Amount"
                    )
                  }}
                </div>
                <div class="text-right">
                  {{ parent.masterCurrency(revenue.amountExludingVatCents) }}
                </div>
              </div>
            </td>
            <td class="text-right">
              <div class="d-flex flex-row justify-space-between">
                <div class="hidden-md-and-up d-print-none font-weight-bold">
                  {{
                    parent.$t(
                      "people:ShoppingBasket.Events.PersonEventFinancialReport.expensesAndIncomes.vatPercent.label",
                      "VAT %"
                    )
                  }}
                </div>
                <div class="text-right">
                  {{ revenue.vatRatePercentage || 0 + "%" }}
                </div>
              </div>
            </td>
            <td class="text-right">
              <div class="d-flex flex-row justify-space-between">
                <div class="hidden-md-and-up d-print-none font-weight-bold">
                  {{
                    parent.$t(
                      "people:ShoppingBasket.Events.PersonEventFinancialReport.expensesAndIncomes.vatAmount.label",
                      "VAT amount"
                    )
                  }}
                </div>
                <div class="text-right">
                  {{ parent.masterCurrency(revenue.vatAmountCents) }}
                </div>
              </div>
            </td>
            <td class="text-right">
              <div class="d-flex flex-row justify-space-between">
                <div class="hidden-md-and-up d-print-none font-weight-bold">
                  {{
                    parent.$t(
                      "people:ShoppingBasket.Events.PersonEventFinancialReport.expensesAndIncomes.totalAmount.label",
                      "Total amount"
                    )
                  }}
                </div>
                <div class="text-right">
                  {{ parent.masterCurrency(revenue.amountCents) }}
                </div>
              </div>
            </td>
          </tr>
        </template>
        <tr :key="i + '-subtotal'">
          <td colspan="4" class="text-left text-lg-right">
            <b>{{
              parent.$t(
                "people:ShoppingBasket.Events.PersonEventFinancialReport.expensesAndIncomes.subTotal.label",
                "Sub-total"
              )
            }}</b>
          </td>
          <td class="text-right">
            <div class="d-flex flex-row justify-space-between">
              <div class="hidden-md-and-up d-print-none font-weight-bold">
                {{
                  parent.$t(
                    "people:ShoppingBasket.Events.PersonEventFinancialReport.expensesAndIncomes.vatAmount.label",
                    "VAT amount"
                  )
                }}
              </div>

              <div class="text-right">
                {{ parent.masterCurrency(registration.subTotalVatCents) }}
              </div>
            </div>
          </td>
          <td class="text-right">
            <div class="d-flex flex-row justify-space-between">
              <div class="hidden-md-and-up d-print-none font-weight-bold">
                <b
                  >{{
                    parent.$t(
                      "people:ShoppingBasket.Events.PersonEventFinancialReport.expensesAndIncomes.totalAmount.label",
                      "Total amount"
                    )
                  }}
                </b>
              </div>
              <div class="text-right">
                <b>{{ parent.masterCurrency(registration.subTotalCents) }} </b>
              </div>
            </div>
          </td>
        </tr>
      </template>
      <tr class="no-hover">
        <td colspan="99" class="pa-0">
          <v-divider style="border-width: 4px" />
        </td>
      </tr>
      <tr class="total-summary">
        <td colspan="5" class="text-left text-lg-right">
          <b>
            {{
              parent.$t(
                "people:ShoppingBasket.Events.PersonEventFinancialReport.expensesAndIncomes.totalExpenses.label",
                "Total expenses (including VAT)"
              )
            }}
          </b>
        </td>
        <td class="text-right">
          <b
            >{{ parent.masterCurrency(props.registrationTotals.totalExpenses) }}
          </b>
        </td>
      </tr>
      <tr class="total-summary">
        <td colspan="5" class="text-left text-lg-right">
          {{
            parent.$t(
              "people:ShoppingBasket.Events.PersonEventFinancialReport.expensesAndIncomes.totalVATCents.label",
              "Total VAT amount"
            )
          }}
        </td>
        <td class="text-right">
          {{ parent.masterCurrency(props.registrationTotals.totalVATCents) }}
        </td>
      </tr>
      <tr class="total-summary">
        <td colspan="5" class="text-left text-lg-right">
          <b>
            {{
              parent.$t(
                "people:ShoppingBasket.Events.PersonEventFinancialReport.expensesAndIncomes.totalIncome.label",
                "Total income"
              )
            }}
          </b>
        </td>
        <td class="text-right">
          <b
            >{{ parent.masterCurrency(props.registrationTotals.totalIncome) }}
          </b>
        </td>
      </tr>

      <tr class="total-summary">
        <td colspan="5" class="text-left text-lg-right">
          <b>
            {{
              parent.$t(
                "people:ShoppingBasket.Events.PersonEventFinancialReport.expensesAndIncomes.totalAmountToPay.label",
                "Total amount to pay (positive) / receive (negative)"
              )
            }}
          </b>
        </td>
        <td class="text-right">
          <b>
            {{
              parent.masterCurrency(props.registrationTotals.totalAmountToPay)
            }}
          </b>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  name: "RegistrationDetailsTable",
  props: {
    registrations: {
      type: Array,
      required: true
    },
    registrationTotals: {
      type: Object,
      required: true
    }
  },
  getName(item) {
    if (item.entryId) {
      const { code, name } = item.entry.competition;
      return code + (name ? ` - ${name}` : "");
    } else if (item.registrationEventProductId) {
      return item.registrationEventProduct.eventProduct.name;
    }
  },
  getNameForRevenue(item, parent) {
    if (item.entryId) {
      const { code, name } = item.entry.competition;
      const { rank } = item.entry;
      return (
        code +
        (name ? ` - ${name}` : "") +
        `, ${rank} ${parent.$t(
          "people:ShoppingBasket.Events.PersonEventBalancesReport.revenueItems.Entry.prizeMoneyPlaceSuffix",
          "place"
        )}`
      );
    } else if (item.registrationEventProductId) {
      return item.registrationEventProduct.eventProduct.name;
    }
  }
};
</script>
<style lang="scss" scoped>
@use "mixin.scss" as c;

.registration-details-table {
  colgroup {
    col:first-child {
      width: 30%;
      @media (max-width: 960px) {
        width: 100%;
      }
    }

    col:nth-child(1n + 3) {
      width: 12%;
      @media (max-width: 960px) {
        width: 0;
      }
    }
    @media only print {
      col {
        width: auto !important;
      }
    }
  }
  .registration-pair-details {
    min-height: 22.5px;
    @media only print {
      display: flex;
      flex-direction: row !important;
    }
  }

  tr {
    td > div.d-flex div:last-child {
      flex-grow: 1;

      @media only screen and (max-width: 960px) {
        flex-grow: 0;
      }
    }
  }

  tr {
    @media only screen and (max-width: 960px) {
      @include c.mobile-row;

      padding-top: 15px;
      padding-bottom: 15px;

      &.header {
        padding-left: 20px;
        padding-right: 20px;

        padding-top: 5px;
        padding-bottom: 5px;
      }

      &.sub-header {
        padding-top: 5px;
        padding-bottom: 5px;

        &:not(.no-hover):hover {
          background: inherit !important;
        }

        td:first-child,
        td:last-child {
          border-bottom: 0 !important;
        }
      }

      &.total-summary {
        padding-top: 5px;
        padding-bottom: 0px;
        border-bottom-color: transparent;
      }

      td {
        padding: 0px;
        &:first-child,
        &:last-child {
          padding-left: 0;
          padding-right: 0;
        }
        padding-top: 8px;
        padding-bottom: 8px;

        &:first-child {
          font-weight: bold;
          font-size: 105%;
          border-bottom: 1px solid grey;
        }

        border-bottom: 1px solid rgba(179, 177, 177, 0.42);

        &:last-child {
          border-bottom-color: transparent;
        }
      }
    }
  }
}
</style>
